import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const IntegrationForm = ({ onSubmit, formSubmitted }) => {
  const navigate = useNavigate();

  const [subjectArea, setSubjectArea] = useState('');
  const [relatedTopics, setRelatedTopics] = useState('');

  useEffect(() => {
    const cookieData = Cookies.get('integrationInfo');
    if (cookieData) {
      try {
        const parsed = JSON.parse(cookieData);
        setSubjectArea(parsed.subjectArea || '');
        setRelatedTopics(parsed.relatedTopics || '');
      } catch (error) {
        console.error('Error parsing integrationInfo cookie:', error);
      }
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const integrationData = {
      subjectArea,
      relatedTopics,
    };

    localStorage.setItem('integrationInfo', JSON.stringify(integrationData));
    Cookies.set('integrationInfo', JSON.stringify(integrationData), { expires: 30 });

    // navigate('/pathwayselection');
    onSubmit(integrationData);
  };

  return (
    <form className="container" onSubmit={handleSubmit}>
      <h5 className="fw-bold">Generate subject area themes 
        <img src={require("../../assets/images/ThemeStormerIcons/chemistry.png")} width="39" className="p-1"></img> 
        <img src={require("../../assets/images/ThemeStormerIcons/history.png")} width="36" className="p-1"></img> 
      </h5>
      <p>Enter your subject area and the optional topic fields to get a list of theme ideas.</p>
      <p className="mb-4 fst-italic text-success">If the fields are already filled with your previous inputs, feel free to edit them.</p>
      <p><span className="text-danger">* </span> Fields required.</p>

      <div className="mb-3">
        <label className="form-label">
          What subject area do you want to integrate with CS? <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          value={subjectArea}
          onChange={(e) => setSubjectArea(e.target.value)}
          required
        />
      </div>

      <div className="mb-3">
        <label className="form-label">
          What are some things (e.g., topics, historical events, fictional characters) related to the subject above that you want to incorporate into your customized Scratch project?
        </label>
        <input
          type="text"
          className="form-control"
          value={relatedTopics}
          onChange={(e) => setRelatedTopics(e.target.value)}
        />
      </div>

      <div className="text-center">
        <button type="submit" className="btn btn-primary" disabled={formSubmitted}>
          Give me theme ideas
        </button>
      </div>
    </form>
  );
}

export default IntegrationForm;